import PropTypes from 'prop-types'

export default function ParagraphLeftAlign({text, children, className, ...props}) {
  return (
    <p className={`text-left mb-0 ${className ? className : ''}`} {...props}>
      {text ? text : null}
      {children}
    </p>
  )
}

ParagraphLeftAlign.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  text: PropTypes.string,
  className: PropTypes.string
}
